// AuthContext.jsx - نسخه نهایی با پشتیبانی از ساختار جدید کاربر و قابلیت ویرایش
import { createContext, useState, useEffect, useContext, useRef, useCallback } from "react";
import { engine } from "../core/books/storage.js";
import dataEngine from "../core/books/data.js";
import { normalizeGradeId, normalizeFieldId } from "../core/education/curriculum.js";
import { getToken, getUserId, removeToken, removeUserId } from '../utils/secureStorage';
import { attachUser, detachUser } from "../core/books/remoteSync.js";

// ✅ همون منطق authService — تا در dev و production درست کار کنه
const getApiBaseUrl = () => {
  const configured = process.env.REACT_APP_API_URL;

  // اگر URL کامل تنظیم شده (مثل http://192.168.1.6:3001) → همون رو استفاده کن
  if (configured && /^https?:\/\//i.test(configured)) {
    return configured;
  }

  // اینجا یعنی configured یا "/api" هست یا خالی.
  // در dev (localhost یا IP محلی) باید مستقیم به json-server (:3001) بریم.
  const hostname = window.location.hostname;
  const isLocalDev =
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    /^192\.168\./.test(hostname) ||
    /^10\./.test(hostname) ||
    /^172\.(1[6-9]|2[0-9]|3[0-1])\./.test(hostname);

  if (isLocalDev) {
    return `http://${hostname}:3001`;
  }

  // production واقعی → از همون /api استفاده کن (Nginx پروکسی می‌کنه)
  return configured || "";
};


// ✅ Base URL سرور — مثل authService

// ✅ سهمیه رایگان ساخت برنامه با AI برای هر کاربر
const AI_PLAN_FREE_QUOTA = 3;




// ================================================================
// ✅ helper: نرمال‌سازی grade و field در هر آبجکت کاربر





// ================================================================
// ✅ helper: نرمال‌سازی grade و field در هر آبجکت کاربر
// ----------------------------------------------------------------
// • grade → '10' به‌جای 'پایه دهم' یا 'دهم' یا '۱۰'
// • field → 'riazi' به‌جای 'ریاضی' یا 'ریاضی فیزیک'
// • برای کاربران قدیمی که با فرمت‌های متفاوت ذخیره شده‌اند
// ----------------------------------------------------------------
// توجه: خروجی این تابع همیشه یک آبجکت جدید است — mutation نمی‌کند.
// ================================================================
function normalizeUserGradeField(user) {
  if (!user || typeof user !== 'object') return user;

  const out = { ...user };

  // فیلدهای اصلی
  if (out.grade) {
    out.grade = normalizeGradeId(out.grade) || out.grade;
  }
  if (out.field) {
    out.field = normalizeFieldId(out.field) || out.field;
  }

  // فیلدهای والدین (برای دانش‌آموز)
  if (out['grade-student']) {
    out['grade-student'] = normalizeGradeId(out['grade-student']) || out['grade-student'];
  }
  if (out['field-student']) {
    out['field-student'] = normalizeFieldId(out['field-student']) || out['field-student'];
  }

  return out;
}





export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
  try {
    const raw = localStorage.getItem('user');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
});

  // ref برای جلوگیری از closure قدیمی در event listener ها
  const userRef = useRef(null);

  // 🆕 ref برای رهگیری کاربر فعلی که به remoteSync وصل شده
  // این جلوی صدا زدن تکراری attachUser رو می‌گیره
  const attachedUserIdRef = useRef(null);

  // ===== خواندن اطلاعات کاربر از localStorage در شروع =====
  // ===== خواندن اطلاعات کاربر از سرور در شروع =====
useEffect(() => {
  const loadUserFromServer = async () => {
    const token = getToken();
    const userId = getUserId();
    if (!token || !userId) {
      setUser(null);
      return;
    }

    // 🆕 گارد آفلاین: اگر اینترنت قطع است، فوراً از حافظه بخوان
    if (!navigator.onLine) {
      try {
        const cachedUser = localStorage.getItem('user');
        if (cachedUser) {
          const parsed = JSON.parse(cachedUser);
          setUser(normalizeUserGradeField(parsed)); // کاربر فوراً لاگین می‌شود
        }
      } catch (e) {
        console.warn('⚠️ خطا در خواندن کاربر از حافظه آفلاین', e);
      }
      return; // خروج فوری بدون منتظر ماندن برای سرور
    }

    try {
      // ✅ خواندن توکن رمزگشایی‌شده (getToken از secureStorage)
      // (توکن قبلاً در بالای تابع خوانده شده، از همان استفاده می‌کنیم)
      
      // ✅ درخواست به دروازه‌بان امن
      const res = await fetch(`/api/db/users/${userId}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (!res.ok) {
        if (res.status === 401 || res.status === 403) {
          // توکن منقضی شده یا نامعتبر است
          removeToken();
          removeUserId();
          setUser(null);
        }
        return;
      }
      const parsed = await res.json();


      // ✅ این بخش حالا با توکن صحیح کار می‌کند (چون token از getToken است)
      const tokenPayload = JSON.parse(atob(token.split('.')[1]));
      if (tokenPayload.role !== parsed.role) {
         console.warn("⚠️ دسترسی...");
      }

      // ===== مهاجرت آواتار از کلید قدیمی =====
      if (!parsed.avatar) {
        const legacy = localStorage.getItem("selectedAvatar");
        parsed.avatar = legacy || "/user-avatar-placeholder.png";
        if (legacy) localStorage.removeItem("selectedAvatar");
       
fetch(`/api/db/users/${parsed.id}`, {
  method: 'PATCH',
  headers: { 
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getToken()}`
  },
  body: JSON.stringify({ avatar: parsed.avatar }),
}).catch(() => {});
      }

      // ✅ نرمال‌سازی grade و field
      const normalized = normalizeUserGradeField(parsed);

      // ✅ مقادیر پیش‌فرض برای سهمیه AI
      if (typeof normalized.aiPlanFreeUsed !== "number") {
        normalized.aiPlanFreeUsed = 0;
      }
      if (typeof normalized.aiPlanFreeTotal !== "number") {
        normalized.aiPlanFreeTotal = AI_PLAN_FREE_QUOTA;
      }

      // 🆕 مقادیر پیش‌فرض برای آرایه‌های per-user (ذخیره در دیتابیس)
      if (!Array.isArray(normalized.paidExams)) {
        normalized.paidExams = [];
      }
      if (!Array.isArray(normalized.publicExamsSeenIds)) {
        normalized.publicExamsSeenIds = [];
      }
      if (!Array.isArray(normalized.ownedAvatars)) {
        normalized.ownedAvatars = [1];
      }
      if (!Array.isArray(normalized.studyTimes)) {
        normalized.studyTimes = [];
      }
      if (typeof normalized.studyReminderEnabled !== 'boolean') {
        normalized.studyReminderEnabled = false;
      }
      // 🆕 آرایه/آبجکت‌های آماری مطالعه (از StudyTimer)
      if (!Array.isArray(normalized.customModes)) {
        normalized.customModes = [];
      }
      if (!normalized.dailyProgress || typeof normalized.dailyProgress !== 'object') {
        normalized.dailyProgress = {};
      }
      if (!Array.isArray(normalized.weeklyProgress)) {
        normalized.weeklyProgress = [0, 0, 0, 0, 0, 0, 0];
      }
      if (!normalized.monthlyProgress || typeof normalized.monthlyProgress !== 'object') {
        normalized.monthlyProgress = {};
      }
      if (!normalized.bookStats || typeof normalized.bookStats !== 'object') {
        normalized.bookStats = {};
      }
      if (!normalized.bookDailyStats || typeof normalized.bookDailyStats !== 'object') {
        normalized.bookDailyStats = {};
      }

      setUser(normalized);
    } catch (e) {
      console.warn('⚠️ خطا در بارگذاری کاربر از سرور:', e);
      setUser(null);
    }
  };
  loadUserFromServer();
}, []);


  // ===== نگه‌داشتن ref به‌روز از user =====
useEffect(() => {
  userRef.current = user;
}, [user]);

// ================================================================
// 🆕 اتصال خودکار به remoteSync هر بار که userId تغییر کرد
// ----------------------------------------------------------------
// چرا این effect لازمه؟
//   تابع attachUser در remoteSync.js لیسنرهای localStorage رو ثبت
//   می‌کنه تا تغییرات رو به سرور push کنه. قبلاً این تابع فقط در
//   login() صدا زده می‌شد، پس بعد از refresh صفحه، sync کاملاً
//   قطع می‌شد. این effect تضمین می‌کنه که:
//     ۱. روی refresh صفحه → attachUser صدا زده بشه
//     ۲. روی login → attachUser صدا زده بشه (idempotent)
//     ۳. روی logout → detachUser صدا زده بشه
//     ۴. روی جابجایی بین کاربران → درست مدیریت بشه
// ================================================================
useEffect(() => {
  const userId = user?.id;

  // --- حالت ۱: کاربر لاگین نیست → جدا شو ---
  if (!userId) {
    if (attachedUserIdRef.current) {
      attachedUserIdRef.current = null;
      detachUser().catch((e) => {
        console.warn('[Auth] detachUser failed:', e);
      });
    }
    return;
  }

  // --- حالت ۲: همون کاربر قبلی → کاری نکن ---
  if (attachedUserIdRef.current === userId) return;

  // --- حالت ۳: کاربر جدید یا اولین بار → وصل شو ---
  attachedUserIdRef.current = userId;
  attachUser(userId).catch((e) => {
    console.warn('[Auth] attachUser failed:', e);
  });
}, [user?.id]);

// ===== ✅ سینک خودکار user با localStorage =====
// این effect تضمین می‌کنه که localStorage.user همیشه با state هماهنگ باشه
// - در login → ذخیره میشه
// - در update → آپدیت میشه
// - در logout → پاک میشه
// - در loadUserFromServer → ذخیره میشه
useEffect(() => {
  const hasAuth = localStorage.getItem('token') && localStorage.getItem('userId');
  
  if (user) {
    // کاربر لاگین کرده → ذخیره کن
    try {
      localStorage.setItem('user', JSON.stringify(user));
    } catch (e) {
      console.warn('⚠️ خطا در ذخیره user در localStorage:', e);
    }
  } else if (!hasAuth) {
    // کاربر logout کرده یا اصلاً لاگین نکرده → پاک کن
    localStorage.removeItem('user');
  }
  // اگه user=null ولی توکن هست، یعنی هنوز داره از سرور می‌خونه → دست نزن
}, [user]);

// ===== همگام‌سازی خودکار teacherProfileId با registry =====
useEffect(() => {
  if (!user?.id || user.role !== 'teacher') return;

  let active = true;
  let unsub = null;
  let readyUnsub = null;
  let timeout = null;

  const syncProfile = () => {
    if (!active) return;
    const u = userRef.current;
    if (!u || u.role !== 'teacher' || !u.id) return;
    try {
      const tp = dataEngine.teacher.getByUserId(u.id);
      if (!tp) return;
      if (u.teacherProfileId === tp.id) return;
      const updated = { ...u, teacherProfileId: tp.id };
      setUser(updated);
      console.log('🔗 teacherProfileId همگام شد:', tp.id);
    } catch (e) {
      console.warn('⚠️ همگام‌سازی teacherProfileId ناموفق:', e);
    }
  };

  const trySync = () => {
    syncProfile();
    if (!unsub && active) {
      unsub = engine.on('registry:teacher:changed', syncProfile);
    }
  };

  if (engine.isReady()) {
    trySync();
  } else {
    // منتظر آماده شدن engine بمون
    readyUnsub = engine.on('engine:ready', trySync);
    // fallback: بعد از ۱۵۰۰ میلی‌ثانیه هم تلاش کن
    timeout = setTimeout(trySync, 1500);
  }

  return () => {
    active = false;
    try { unsub && unsub(); } catch {}
    try { readyUnsub && readyUnsub(); } catch {}
    try { clearTimeout(timeout); } catch {}
  };
}, [user?.id, user?.role]);






  // ===== به‌روزرسانی کاربر در سرور =====
  // ✅ اصلاح: fetch خارج از setUser → در StrictMode دوبار اجرا نمی‌شود
  const updateUser = useCallback((updates) => {
    if (!updates || typeof updates !== 'object') return;

    setUser((prev) => {
      if (!prev) return prev;
      const merged = normalizeUserGradeField({ ...prev, ...updates });
      return merged;
    });

    // ✅ از userRef استفاده کن تا آخرین مقدار user را داشته باشی
    const currentUser = userRef.current;
    const userId = currentUser?.id || updates?.id;
    if (!userId) return;

    // ✅ ذخیره در سرور (PATCH /api/db/users/:id) — بیرون از setUser
    fetch(`/api/db/users/${userId}`, {
      method: 'PATCH',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${getToken()}`  // ← توکن رمزگشایی‌شده
      },
      body: JSON.stringify(updates),
    }).catch((e) => {
      console.warn("⚠️ خطا در ذخیره کاربر در سرور:", e);
    });
  }, []);

  // ===== توابع مربوط به سکه و امتیاز =====
  // ⚠️ منبع اصلی CoinContext است؛ این تابع فقط برای سازگاری نگه داشته شده
  const getUserRewards = () => {
    if (!user) return { coins: 0, xp: 0 };
    return {
      coins: Number(user.coins) || 0,
      xp: Number(user.xp) || 0,
    };
  };

  // ⚠️ سکه و امتیاز حالا در CoinContext و مجموعه userRewards سرور مدیریت می‌شود
  // این تابع فقط user.coins و user.xp را در حافظه و سرور به‌روزرسانی می‌کند
  const updateUserRewards = useCallback((coins, xp) => {
    const currentUser = userRef.current;
    if (!currentUser?.id) return;

    const updatedUser = normalizeUserGradeField({ ...currentUser, coins, xp });
    setUser(updatedUser);

    // ذخیره در سرور
    fetch(`/api/db/users/${currentUser.id}`, {
      method: 'PATCH',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${getToken()}`
      },
      body: JSON.stringify({ coins, xp }),
    }).catch((e) => {
      console.warn("⚠️ خطا در ذخیره سکه/امتیاز در سرور:", e);
    });
  }, []);

  // ===== ورود =====
  // ⚠️ توکن و userId قبلاً توسط authService در localStorage ذخیره شده‌اند
  const login = (userData) => {
    const userWithDefaults = normalizeUserGradeField({
      ...userData,
      coins: userData.coins ?? 0,
      xp: userData.xp ?? 0,
      aiPlanFreeUsed: userData.aiPlanFreeUsed ?? 0,
      aiPlanFreeTotal: userData.aiPlanFreeTotal ?? AI_PLAN_FREE_QUOTA,
      // 🆕 آرایه‌های per-user (در دیتابیس ذخیره می‌شن)
      paidExams: Array.isArray(userData.paidExams) ? userData.paidExams : [],
      publicExamsSeenIds: Array.isArray(userData.publicExamsSeenIds) ? userData.publicExamsSeenIds : [],
      ownedAvatars: Array.isArray(userData.ownedAvatars) ? userData.ownedAvatars : [1],
      studyTimes: Array.isArray(userData.studyTimes) ? userData.studyTimes : [],
      studyReminderEnabled: typeof userData.studyReminderEnabled === 'boolean' ? userData.studyReminderEnabled : false,
      // 🆕 آمار مطالعه
      customModes: Array.isArray(userData.customModes) ? userData.customModes : [],
      dailyProgress: userData.dailyProgress && typeof userData.dailyProgress === 'object' ? userData.dailyProgress : {},
      weeklyProgress: Array.isArray(userData.weeklyProgress) ? userData.weeklyProgress : [0, 0, 0, 0, 0, 0, 0],
      monthlyProgress: userData.monthlyProgress && typeof userData.monthlyProgress === 'object' ? userData.monthlyProgress : {},
      bookStats: userData.bookStats && typeof userData.bookStats === 'object' ? userData.bookStats : {},
      bookDailyStats: userData.bookDailyStats && typeof userData.bookDailyStats === 'object' ? userData.bookDailyStats : {},
      createdAt: userData.createdAt || new Date().toISOString(),
    });

    // ===== اطمینان از وجود آواتار =====
    if (!userWithDefaults.avatar) {
      const legacy = localStorage.getItem("selectedAvatar");
      userWithDefaults.avatar = legacy || "/user-avatar-placeholder.png";
      if (legacy) localStorage.removeItem("selectedAvatar");
    }

    setUser(userWithDefaults);



    attachUser(userWithDefaults.id);
  };

  // ===== خروج =====
  const logout = () => {
    setUser(null);
    removeToken();
    removeUserId();
    detachUser().catch(() => {});
  };






  // ===== به‌روزرسانی user از سرور =====
  const refreshUser = async () => {
    try {
      const userId = getUserId();
      if (!userId) return null;
      const res = await fetch(`/api/db/users/${userId}`, {
        headers: { 'Authorization': `Bearer ${getToken()}` }
      });
      if (!res.ok) return null;
      const parsed = await res.json();
      const normalized = normalizeUserGradeField(parsed);

      // 🆕 مقادیر پیش‌فرض برای آرایه‌های per-user
      if (!Array.isArray(normalized.paidExams)) {
        normalized.paidExams = [];
      }
      if (!Array.isArray(normalized.publicExamsSeenIds)) {
        normalized.publicExamsSeenIds = [];
      }
      if (!Array.isArray(normalized.ownedAvatars)) {
        normalized.ownedAvatars = [1];
      }
      if (!Array.isArray(normalized.studyTimes)) {
        normalized.studyTimes = [];
      }
      if (typeof normalized.studyReminderEnabled !== 'boolean') {
        normalized.studyReminderEnabled = false;
      }
      // 🆕 آرایه/آبجکت‌های آماری مطالعه
      if (!Array.isArray(normalized.customModes)) {
        normalized.customModes = [];
      }
      if (!normalized.dailyProgress || typeof normalized.dailyProgress !== 'object') {
        normalized.dailyProgress = {};
      }
      if (!Array.isArray(normalized.weeklyProgress)) {
        normalized.weeklyProgress = [0, 0, 0, 0, 0, 0, 0];
      }
      if (!normalized.monthlyProgress || typeof normalized.monthlyProgress !== 'object') {
        normalized.monthlyProgress = {};
      }
      if (!normalized.bookStats || typeof normalized.bookStats !== 'object') {
        normalized.bookStats = {};
      }
      if (!normalized.bookDailyStats || typeof normalized.bookDailyStats !== 'object') {
        normalized.bookDailyStats = {};
      }

      setUser(normalized);
      return normalized;
    } catch (e) {
      console.warn("⚠️ refreshUser failed:", e);
    }
    return null;
  };

  // ============================================================
  // ✅ توابع سهمیه رایگان ساخت برنامه با AI
  // ============================================================

  /** خواندن وضعیت فعلی سهمیه */
  const getAIQuota = () => {
    const used = Number(user?.aiPlanFreeUsed) || 0;
    const t = Number(user?.aiPlanFreeTotal);
    const total = Number.isFinite(t) ? t : AI_PLAN_FREE_QUOTA;
    return {
      used,
      total,
      remaining: Math.max(0, total - used),
    };
  };

  /** مصرف یک واحد از سهمیه رایگان. اگر تمام شده باشد false برمی‌گرداند */
  const consumeAIQuota = () => {
    const { used, total } = getAIQuota();
    if (used >= total) return false;
    updateUser({ aiPlanFreeUsed: used + 1 });
    return true;
  };

  /** بازگرداندن یک واحد به سهمیه (در صورت شکست درخواست) */
  const refundAIQuota = () => {
    const used = Number(user?.aiPlanFreeUsed) || 0;
    if (used > 0) updateUser({ aiPlanFreeUsed: used - 1 });
  };










  return (
    <AuthContext.Provider
      value={{
  user,
  login,
  logout,
  updateUser,
  getUserRewards,
  updateUserRewards,
  refreshUser,
  // helper های امن برای معلم (اختیاری — فقط برای راحتی)
  isTeacher: user?.role === 'teacher',
  hasTeacherProfile: !!user?.teacherProfileId,
  teacherProfileId: user?.teacherProfileId || null,
  // ✅ سهمیه AI — برای کل اپ
  aiQuota: getAIQuota(),
  consumeAIQuota,
  refundAIQuota,
  AI_PLAN_FREE_QUOTA,
}}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}